import { commonConstants } from "./types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case commonConstants.GET_AYDINLATMA_REQUEST:
      return {
        ...state
      };
    case commonConstants.GET_AYDINLATMA_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case commonConstants.SET_AYDINLATMA_REQUEST:
      return {
        ...state
      };
    case commonConstants.SET_AYDINLATMA_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
      case commonConstants.HIDE_AYDINLATMA_MODAL:
      return {
        ...state,
        durum: false
      };
    case commonConstants.AYDINLATMA_ERROR:
      return {};
    default:
      return state;
  }
};
